export function csrfToken() {
  try {
    const meta: HTMLMetaElement | null = document.querySelector(
      "meta[name=csrf-token]"
    );

    return meta?.content ?? "";
  } catch (error) {
    return "";
  }
}

async function get(path: string) {
  const response = await fetch(`/api/${path}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
  });

  return await response.json();
}

async function post(path: string, body = {}) {
  const response = await fetch(`/api/${path}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify(body),
  });

  return await response.json();
}

async function patch(path: string, body = {}) {
  const response = await fetch(`/api/${path}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify(body),
  });

  const responseData = await response.text();

  if (responseData) {
    return JSON.parse(responseData);
  }

  return null;
}

async function destroy(path: string) {
  const response = await fetch(`/api/${path}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
  });

  return response;
}

export { get, post, patch, destroy };
